/* global axios */
import ApiClient from './ApiClient';

class TalkviaInventoryProductsAPI extends ApiClient {
  constructor() {
    super('talkvia_inventory_products', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, { talkvia_inventory_product: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, {
      talkvia_inventory_product: data,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  stockByDate(id, date) {
    return axios.get(`${this.url}/${id}/stock_by_date`, { params: { date } });
  }

  // Menor quantidade livre de produtos e grupos entre a entrega e a véspera da retirada.
  availability({ from, to, productIds = [], groupIds = [] }) {
    return axios.get(`${this.url}/availability`, {
      params: {
        from,
        to: to || undefined,
        product_ids: productIds,
        group_ids: groupIds,
      },
    });
  }
}

export default new TalkviaInventoryProductsAPI();
